import { ZfFileItem, ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteAppendixDocument, useDocuments, useRemoveDocument } from '../../api';
import type { ClientPackageAppendixDocumentDto } from '../../api/generated/client';
import type { IPackageDocument } from '../../interfaces/package';
import { DocumentListItem } from './DocumentListItem';

interface IProps {
    clientId: number;
    packageId?: number;
    hasDraftPackage: boolean;
    hasDocs: boolean;
    clientPackageDocuments: IPackageDocument[];
    additionalDocuments: ClientPackageAppendixDocumentDto[];
}

export const DocumentList: FunctionComponent<IProps> = ({ clientId, packageId, hasDraftPackage, hasDocs, clientPackageDocuments, additionalDocuments }) => {
    const { t, i18n } = useTranslation();
    const { data: allDocuments } = useDocuments();

    const deleteAppendixDocument = useDeleteAppendixDocument(clientId);
    const removeDocument = useRemoveDocument(clientId, packageId);

    if (!allDocuments) {
        return <ZfLoadingSpinner />;
    }

    if (!hasDraftPackage) {
        return <DocumentListItem emptyText={true}>{t('clientDraftPackageEmpty')}</DocumentListItem>;
    }

    if (!hasDocs) {
        return <DocumentListItem emptyText={true}>{t('clientPackageEmpty')}</DocumentListItem>;
    }

    return (
        <>
            {additionalDocuments.map((document) => (
                <DocumentListItem key={document.documentId}>
                    <ZfFileItem name={document.filename} downloadable={false} onFileDelete={() => deleteAppendixDocument.mutateAsync(document.documentId)} />
                </DocumentListItem>
            ))}
            {allDocuments
                .filter((document) => clientPackageDocuments.some(({ documentId }) => documentId === document.id))
                .map((document) => (
                    <DocumentListItem key={document.id}>
                        <ZfFileItem name={document.name[i18n.language]} downloadable={false} onFileDelete={() => removeDocument.mutateAsync(document.id)} />
                    </DocumentListItem>
                ))}
        </>
    );
};
